import "./Booking.css";
import "../listingPage/listingPage.css";
import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';

const Booking = () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [showModal, setShowModal] = useState(false);
    const [bookingData, setBookingData] = useState(null);
    const [activeTab, setActiveTab] = useState("upcoming");
    const [upsellloading, setupsellloading] = useState(false)

    const handleShow = (ID, PNR) => {
        setShowModal(true);      // open first
        setBookingData(null);
        // Fetch booking details for modal using a POST request with payload
        const fetchBookingDetails = async () => {
            try {
                const payload = {
                    bookingId: String(ID),
                    PNR: String(PNR)
                };
                const response = await fetch(`${baseUrl}api/Flight/BookingDetail`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + bearerToken,
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    throw new Error(`Error ${response.status}: ${response.statusText}`);
                }

                const result = await response.json();
                console.log("booking data", result)
                setBookingData(result?.Data);

            } catch (error) {
                console.error('Error fetching modal data:', error);
                setBookingData(null);
            }

        };
        fetchBookingDetails();
    };

    const handleClose = () => {
        console.log("Before closing modal:", showModal);
        setShowModal(false);
        console.log("After closing modal:", showModal);
    };



    const bearerToken = localStorage.getItem('bearerToken');
    // if (bearerToken === '' || bearerToken === undefined || bearerToken === null)
    //     window.location.href = '/login';
    const [searchQuery, setSearchQuery] = useState("");

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };
    const [bookinglsts, setBookinglsts] = useState([]);

    const getBookings = async () => {
        if (!bearerToken) {
            console.error('No token found');
            return;
        }
        setupsellloading(true)
        try {
            // const response = await fetch(`https://cbtapi.blueberry-travel.com/api/FlightBooking/getBookingDetail?bookingId=0`, {
            const response = await fetch(`${baseUrl}api/Flight/BookingList`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + bearerToken,
                }
            });
            setupsellloading(false)
            if (!response.ok) {
                localStorage.removeItem("bearerToken");
                window.location.href = "/login";
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            const result = await response.json();
            console.log("Booking List", result.Data);
            setBookinglsts(result.Data);


        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(() => {
        getBookings();
    }, []);
    const filteredBookings = bookinglsts.filter((booking) => {
        if (activeTab === "upcoming") return booking.status === 1;
        if (activeTab === "cancelled") return booking.status === 3;
        if (activeTab === "completed") return booking.status === 2;
        return false;
    });

    const searchedBookings = filteredBookings.filter((booking) => {
        if (!searchQuery) return true;

        const departureCity =
            booking?.departure_city?.toLowerCase() || "";

        const arrivalCity =
            booking?.arrival_city?.toLowerCase() || "";

        const departureDate = booking?.departure_datetime.split("T")[0]
            ? new Date(booking.departure_datetime.split("T")[0])
                .toLocaleDateString("en-GB") // 10/02/2025
                .toLowerCase()
            : "";

        const arrivalDate = booking?.arrival_datetime.split("T")[0]
            ? new Date(booking.arrival_datetime.split("T")[0])
                .toLocaleDateString("en-GB") // 10/02/2025
                .toLowerCase()
            : "";

        return (
            departureCity.includes(searchQuery) ||
            arrivalCity.includes(searchQuery) ||
            departureDate.includes(searchQuery) ||
            arrivalDate.includes(searchQuery)
        );
    });


    return (
        <>
            <div className="profileBooking p-3">
                <h5 className="text-white text-start container">Bookings</h5>
            </div>
            <div className="profileMainContainer py-5">
                <div className="container row m-auto personalInfoDiv">
                    <div className="personalInfoLeft">
                        <div className='personalUserimg'>
                            <h5 className='text-start'>Your Bookings</h5>
                        </div>
                        <div className="profileOptions">
                            <button
                                className={`BookingButtons ${activeTab === "upcoming" ? "active" : ""}`}
                                onClick={() => setActiveTab("upcoming")}
                            >
                                <img src="./assets/images/upcomingIcon.png" alt="Upcoming" />
                                <p className="m-0">Upcoming</p>
                            </button>

                            <button
                                className={`BookingButtons ${activeTab === "cancelled" ? "active" : ""}`}
                                onClick={() => setActiveTab("cancelled")}
                            >
                                <img src="/assets/images/cancelIcon.png" alt="Cancelled" />
                                <p className="m-0">Cancelled</p>
                            </button>

                            <button
                                className={`BookingButtons ${activeTab === "completed" ? "active" : ""}`}
                                onClick={() => setActiveTab("completed")}
                            >
                                <img src="/assets/images/completeIcon.png" alt="Completed" />
                                <p className="m-0">Completed</p>
                            </button>
                        </div>

                    </div>
                    <div className='ProfileRightContainer'>
                        <div className="personalInfoRight">
                            <div className="bookingSearchBar">
                                <input type="text" placeholder='Search For Booking' value={searchQuery}
                                    onChange={handleSearchChange} />
                                <img src="/assets/images/searchIcon.png" alt="" />
                            </div>
                        </div>
                        <div className="personalInfoRight mt-4">
                            <div className="text-start fw-semibold p-3" style={{ backgroundColor: "#FAFAFA", borderRadius: "15px 15px 0px 0px ", fontSize: "18px" }}>
                                {activeTab === "upcoming" && "Upcoming Bookings"}
                                {activeTab === "cancelled" && "Cancelled Bookings"}
                                {activeTab === "completed" && "Completed Bookings"}
                            </div>
                            <div className="personalInfoContainer">
                                <div className="infoCard">
                                    {searchedBookings.length > 0 ? (

                                        searchedBookings.map((flightdata, index) => (
                                            <>
                                            
                                                {/* <div className="cardHeader" key={index}>
                                                    {((flightdata?.status === "1") && index === 0) && (<h5>Upcoming Bookings</h5>)}
                                                </div> */}

                                                {((flightdata?.status === 1) && (
                                                    <div className='upcommingMainBox my-4'>

                                                        <div className='flightdetailLeftContainer '>
                                                            {/* <div className="airline">
                                                            <img src={`https://r-xx.bstatic.com/data/airlines_logo/${flightdata?.OperatingAirline.code}.png`} alt={flightdata?.OperatingAirline.name} className="airlineIconimg" />
                                                            <span className='d-flex text-muted'> <h5 className='text-dark metropolis-semibold'> {flightdata?.OperatingAirline.name} </h5> &nbsp; | &nbsp;  {flightdata?.OperatingAirline?.code} • {flightdata?.OperatingAirline?.number} </span>
                                                        </div> */}

                                                            <div className="bookingData?.Booking px-2 py-3 d-flex justify-content-between" style={{ background: "linear-gradient(180deg, #CFEEF6 0%, rgba(207, 238, 246, 0) 100%)" }}>

                                                                {/* Departure */}
                                                                <div className="departure departure-width text-start">

                                                                    <h5 className='text-dark metropolis-semibold'> {flightdata?.departure_city}</h5>
                                                                    <span className="location">
                                                                        {flightdata?.departure_city} - {flightdata?.departure_code}
                                                                    </span>

                                                                    <span className="airport">
                                                                        {flightdata?.departure_name}
                                                                    </span>

                                                                    <h6 className="time metropolis-bold mt-4">
                                                                        {flightdata?.departure_datetime?.split("T")[1]?.slice(0, 5)}
                                                                    </h6>

                                                                    <span className="date text-dark metropolis-semibold">
                                                                        {new Date(flightdata?.departure_datetime).toLocaleDateString("en-US", {
                                                                            weekday: "short",
                                                                            day: "numeric",
                                                                            month: "short",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>
                                                                </div>

                                                                {/* Duration */}
                                                                <span className="mx-3 " style={{ color: "black !important", fontSize: "30px" }}>
                                                                    {flightdata.triptype?.toLowerCase() === "oneway" ? "⇀" : "⇌"}
                                                                </span>

                                                                {/* Arrival */}
                                                                <div className="arrival arrival-width text-start">

                                                                    <h5 className='text-dark metropolis-semibold'> {flightdata?.arrival_city}</h5>
                                                                    <span className="location">
                                                                        {flightdata?.arrival_city} - {flightdata?.arrival_code}
                                                                    </span>

                                                                    <span className="airport">
                                                                        {flightdata?.arrival_name}
                                                                    </span>

                                                                    <h6 className="time metropolis-bold mt-4">
                                                                        {flightdata?.arrival_datetime?.split("T")[1]?.slice(0, 5)}
                                                                    </h6>

                                                                    <span className="date text-dark metropolis-semibold">
                                                                        {new Date(flightdata?.arrival_datetime).toLocaleDateString("en-US", {
                                                                            weekday: "short",
                                                                            day: "numeric",
                                                                            month: "short",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>

                                                                </div>


                                                            </div>


                                                        </div>
                                                        <div className=" border-top p-3">
                                                            {/* Status */}
                                                            <div className="status-badge mb-3">
                                                                {flightdata?.status === 1 ? "confirmed" : ""}
                                                            </div>

                                                            {/* Buttons */}
                                                            <div className="d-flex justify-content-between flex-wrap card-buttons">
                                                                <button className="btn  action-btn" style={{ color: "#167182" }}>
                                                                    Reschedule
                                                                </button>

                                                                <button className="btn action-btn" style={{ color: "#B40000" }}>
                                                                    Cancel Booking
                                                                </button>

                                                                <button className="btn  action-btn" style={{ color: "#167182" }} onClick={() => handleShow(flightdata.id, flightdata.PNR)}>
                                                                    View Details
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className='upcomingBtns'>
                                                            {/* <button>Reschedule</button>
                                                            {new Date(b?.bookingDetail?.canceldate) < new Date() && (
                                                                <button className='text-danger border-danger'>Cancel Booking</button>)}
                                                            <button onClick={() => handleShow(b)}>View Details</button> */}
                                                        </div>
                                                    </div>))}
                                            </>
                                        ))) : (
                                        activeTab === "upcoming" ? (
                                            <div className="container empty-state">
                                                <div className="text-center py-5">
                                                    <img src="./assets/images/Upcoming-Booking.png" style={{ width: "18rem" }} />
                                                    <p class="empty-text">
                                                        No upcoming bookings. Plan your next journey now!
                                                    </p>
                                                    <button
                                                        className="buttonBookFlight"
                                                        onClick={() => window.location.href = '/'}
                                                    >
                                                        Book a Flight
                                                    </button>
                                                </div>
                                            </div>
                                        ) : activeTab === "cancelled" ? (
                                            <div className="container empty-state">
                                                <div className="text-center py-5">
                                                    <img src="./assets/images/Cancel-Booking.png" alt="No bookings" style={{ width: "18rem" }} />
                                                    <p class="empty-text">
                                                        No canceled bookings. Manage your travel plans smoothly.
                                                    </p>
                                                    <button
                                                        className="buttonBookFlight"
                                                        onClick={() => window.location.href = '/'}
                                                    >
                                                        Book a Flight
                                                    </button>
                                                </div>
                                            </div>
                                        ) : activeTab === "completed" ? (
                                            <div className="container empty-state">
                                                <div className="text-center py-5">
                                                    <img src="./assets/images/Complete-Booking.png" style={{ width: "18rem" }} />
                                                    <p class="empty-text">
                                                        No completed bookings yet. Start exploring the world!
                                                    </p>
                                                    <button
                                                        className="buttonBookFlight"
                                                        onClick={() => window.location.href = '/'}
                                                    >
                                                        Book a Flight
                                                    </button>
                                                </div>
                                            </div>
                                        ) : null
                                    )
                                    }
                                    {showModal && (
                                        <>

                                            <Modal
                                                show={showModal}
                                                onHide={handleClose}
                                                size="xl"
                                                centered
                                                dialogClassName="mmt-booking-modal"
                                            >

                                                <Modal.Body className="p-0 bg-light">
                                                    <div style={{  textAlign: "end",
                                                                padding: "15px 31px 0px 29px",}}>
                                                        <button
                                                            onClick={handleClose}
                                                            style={{
                                                                // position: "absolute",
                                                                top: "16px",
                                                                right: "24px",
                                                                background: "transparent",
                                                                border: "none",
                                                                fontSize: "1.7rem",
                                                                cursor: "pointer",
                                                              
                                                            }}
                                                            aria-label="Close"
                                                        >
                                                            &times;
                                                        </button>
                                                    </div>
                                                    {/* TOP HEADER: Dynamic Colors based on Status */}
                                                    <div className="booking-header p-4">
                                                        <div className="d-flex justify-content-between align-items-start flight-details">
                                                            <div>
                                                                <div className="text-uppercase small fw-bold opacity-75 mb-1 tracking-wider">
                                                                    {bookingData?.Booking.triptype} Flight
                                                                </div>
                                                                <h3 className="fw-bold mb-0">
                                                                    {bookingData?.Booking.departure_city}
                                                                    <span className="mx-3 text-warning">
                                                                        {bookingData?.Booking.triptype?.toLowerCase() === "oneway" ? "⇀" : "⇌"}
                                                                    </span>
                                                                    {bookingData?.Booking.arrival_city}
                                                                </h3>
                                                                <p className="mb-0 opacity-90 small booking-details">
                                                                    Booking ID: #{bookingData?.Booking.id} • Confirmed on {new Date(bookingData?.Booking.createddate).toLocaleDateString()}
                                                                </p>
                                                            </div>
                                                            <div className="text-end d-flex flex-column gap-2">
                                                                {bookingData?.Booking.status === 1 && (
                                                                    <div className="badge bg-success-soft text-success border border-success">
                                                                        ● Confirmed
                                                                    </div>
                                                                )}
                                                                {bookingData?.Booking.status === 3 && (
                                                                    <div className="badge bg-danger-soft text-danger border border-danger">
                                                                        ● Cancelled
                                                                    </div>
                                                                )}
                                                                <div className="pnr-badge mb-2">
                                                                    <span className="label">PNR</span>
                                                                    <span className="code">{bookingData?.Booking.PNR}</span>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="p-4">
                                                        <h5 className="traveller-title">Flight Details</h5>

                                                        <div className="itinerary-container">
                                                            {bookingData?.FlightDetails.map((f, i) => (
                                                                <React.Fragment key={i}>
                                                                    {f.connectiontime && (
                                                                        <div className="makeFlex mb-3 text-center">
                                                                            <b style={{ color: "#1FD78A" }}>Change of planes</b>・
                                                                            &nbsp;Layover in {f.departure_city}: {Math.floor(f.connectiontime / 60)}h {f.connectiontime % 60}m
                                                                        </div>
                                                                    )}
                                                                    <div className="flight-segment-card mb-3">
                                                                        <div className="segment-header">
                                                                            <div className="airline-info" style={{ width: "100%" }}>
                                                                                <img src={`https://r-xx.bstatic.com/data/airlines_logo/${f?.marketing_airline_code}.png`} alt={f?.marketing_airline_code} className="airlineIconimg" />
                                                                                <div>
                                                                                    <div className="fw-bold">{f.marketing_airline_name}</div>
                                                                                    <div className="text-muted extra-small">{f.marketing_airline_code} {f.flightnumber} • Aircraft {f.equipment}</div>
                                                                                </div>
                                                                            </div>
                                                                            {/* <div className="cabin-badge">{f.cabin_class_text === 'M' ? 'Economy' : f.cabin_class_text}</div> */}
                                                                        </div>

                                                                        <div className="flight px-2 py-3 w-100">
                                                                            <div className="departure departure-width">
                                                                                <h4 className="time metropolis-bold">{f.departure_datetime.split("T")[1].slice(0, 5)}</h4>

                                                                                <span className="location">{f?.departure_city} - {f?.departure_code}</span>
                                                                                <span className="airport">{f?.departure_name}</span>

                                                                                {f?.DepartureTerminal && (
                                                                                    <h6 className="terminal text-dark metropolis-semibold">
                                                                                        Terminal {f?.DepartureTerminal}
                                                                                    </h6>
                                                                                )}
                                                                            </div>
                                                                            <div className="duration-container duration-container-width">
                                                                                <div>
                                                                                    <div className="duration-time my-2">{Math.floor(f?.flightminute / 60)}h&nbsp;
                                                                                        {f?.flightminute % 60}m</div>
                                                                                    <div className="duration-graphic">
                                                                                        <img src="/assets/images/flightIconListing.png" alt="" className='duration-graphic-img' />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="arrival arrival-width1">
                                                                                <div>
                                                                                    <h4 className="time metropolis-bold">{f.arrival_datetime.split("T")[1].slice(0, 5)}</h4>

                                                                                    <span className="location">{f?.arrival_city} - {f?.arrival_code}</span>
                                                                                    <span className="airport">{f?.arrival_name}</span>

                                                                                    {f?.ArrivalTerminal && (
                                                                                        <h6 className="terminal text-dark metropolis-semibold">
                                                                                            Terminal {f?.ArrivalTerminal}
                                                                                        </h6>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </React.Fragment>
                                                            ))}
                                                        </div>

                                                        <div className="mt-4 d-flex flex-column gap-4">

                                                            <div>

                                                                {bookingData?.PaxDetails?.length > 0 && (
                                                                    <>
                                                                        <div className="traveller-card">
                                                                            <h5 className="traveller-title">Traveller details</h5>

                                                                            {bookingData?.PaxDetails.map((pax, index) => {
                                                                                const travellerType =
                                                                                    pax.paxtype === 1 ? "Adult" :
                                                                                        pax.paxtype === 2 ? "Child" :
                                                                                            pax.paxtype === 3 ? "Infant" : "";

                                                                                const gender =
                                                                                    pax.gender === 1 ? "Male" :
                                                                                        pax.gender === 2 ? "Female" : "";

                                                                                return (
                                                                                    <div className="traveller-row" key={index}>
                                                                                        <div className="traveller-icon">
                                                                                            <img src="/assets/images/user icon.png" alt="" />
                                                                                        </div>

                                                                                        <div>
                                                                                            <div className="traveller-name">
                                                                                                {pax.title} {pax.firstname} {pax.lastname}
                                                                                            </div>

                                                                                            <div className="traveller-meta">
                                                                                                {travellerType} ● {gender} ● &nbsp;
                                                                                                {new Date(pax.dateofbirth).toLocaleDateString("en-GB", {
                                                                                                    day: "2-digit",
                                                                                                    month: "short",
                                                                                                    year: "numeric",
                                                                                                })}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                        <div>
                                                                            <h5 className="traveller-title">Contact Details</h5>
                                                                            <div className="details-card" style={{ padding: "18px 0px" }}>
                                                                                <div style={{
                                                                                    display: "flex",
                                                                                    alignItems: "flex-start",
                                                                                    gap: "14px"
                                                                                }}>
                                                                                    <div className="traveller-icon">
                                                                                        <img src="/assets/images/mail-and-phone-2562.png" alt="" />
                                                                                    </div>

                                                                                    <div>
                                                                                        {/* Mobile Number */}
                                                                                        <div style={{
                                                                                            fontSize: "19px",
                                                                                            fontWeight: 400,
                                                                                            letterSpacing: 0.2,
                                                                                            color: "#222",
                                                                                            marginBottom: "4px"
                                                                                        }}>
                                                                                            {bookingData?.PaxDetails?.[0]?.contactee_phone_number
                                                                                                ? `+${bookingData?.PaxDetails?.[0]?.contactee_phone_country_code || ""}${bookingData?.PaxDetails?.[0]?.contactee_phone_number}`
                                                                                                : "N/A"}
                                                                                        </div>
                                                                                        {/* Email */}
                                                                                        <div style={{
                                                                                            fontSize: "17px",
                                                                                            fontWeight: 400,
                                                                                            color: "#222"
                                                                                        }}>
                                                                                            {bookingData?.PaxDetails?.[0]?.contactee_email || "N/A"}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>

                                                            {/* BAGGAGE */}
                                                            <div>
                                                                <h5 className="traveller-title">Baggage Policy</h5>
                                                                <div className="details-card">
                                                                    {bookingData?.Baggages.map((b, i) => (
                                                                        <div key={i} className="d-flex justify-content-between mb-2 last-child-0">
                                                                            <span className="small fw-medium">{b.departure_iata}-{b.arrival_iata}</span>
                                                                            <span className={`small ${b.value === 'No Baggage' ? 'text-danger' : 'text-success'}`}>
                                                                                {b.value}
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="fare-summary-card mt-4">
                                                            <div className="row align-items-center">
                                                                <div className="col-6">
                                                                    <div className="text-muted small">Total Paid Amount</div>
                                                                    <div className="fw-bold h4 mb-0">
                                                                        {bookingData?.PriceBreakdowns[0].currency} {bookingData?.PriceBreakdowns[0].total.toLocaleString()}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal.Body>

                                                <Modal.Footer className="border-0">
                                                    <button className="btn btn-outline-secondary" onClick={handleClose}>
                                                        Close
                                                    </button>
                                                </Modal.Footer>
                                            </Modal>
                                        </>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {upsellloading && (
                <>
                    <div className="loaderbg"></div>

                    <div className="loaderUpselling">
                        <img src="./assets/images/Flight-price-loader.gif" alt="Loading" />
                    </div>
                </>
            )}
        </>
    );
};
export default Booking;
